import { CarouselApi } from '@/shadcn/ui/carousel';
import { useEffect, useState } from 'react';

export interface IUseCarouselApi {
  api: CarouselApi | undefined;
  setApi: (api: CarouselApi) => void;
  current: number;
  handleNext: () => void;
  handlePrev: () => void;
  count: number;
  isFirst: boolean;
  isLast: boolean;
  setCurrent: (index: number) => void;
}

export function useCarouselApi(): IUseCarouselApi {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    const updateCurrent = () => {
      setCurrent(api.selectedScrollSnap() + 1);
    };

    const updateCount = () => {
      setCount(api.scrollSnapList().length);
    };

    updateCount();
    updateCurrent();
    api.on('select', updateCurrent);
    api.on('reInit', updateCount);
    api.on('reInit', updateCurrent);

    return () => {
      api.off('select', updateCurrent);
      api.off('reInit', updateCount);
      api.off('reInit', updateCurrent);
    };
  }, [api]);

  const handleNext = () => {
    if (api) {
      api.scrollNext();
    }
  };

  const handlePrev = () => {
    if (api) {
      api.scrollPrev();
    }
  };

  const isFirst = current === 1;
  const isLast = current === count;

  return {
    api,
    setApi,
    current,
    handleNext,
    handlePrev,
    count,
    isFirst,
    isLast,
    setCurrent,
  };
}
